import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import { Clock, BookOpen, Target } from 'lucide-react';

/**
 * Composant d'affichage des recommandations simplifié
 * Parse le contenu en sections avec une police plus grande
 */
const RecomDisplay = ({ content }) => {
  // Fonction pour parser le contenu en sections
  const parseContent = (content) => {
    if (!content) return { section1: 'Chargement...', section2: '', section3: '' };
    
    const sections = {
      section1: '',
      section2: '',
      section3: ''
    };
    
    const section1Match = content.match(/\[SECTION1\]([\s\S]*?)(\[SECTION2\]|$)/);
    if (section1Match) sections.section1 = section1Match[1].trim();
    
    const section2Match = content.match(/\[SECTION2\]([\s\S]*?)(\[SECTION3\]|$)/);
    if (section2Match) sections.section2 = section2Match[1].trim();
    
    const section3Match = content.match(/\[SECTION3\]([\s\S]*?)$/);
    if (section3Match) sections.section3 = section3Match[1].trim();
    
    return sections;
  };
  
  const sections = parseContent(content);
  
  // Style personnalisé pour augmenter la taille de police
  const customStyles = `
    .markdown-content {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
    .markdown-content p {
      margin-bottom: 1rem;
    }
    .markdown-content strong {
      font-weight: 600;
    }
  `;
  
  return (
    <div className="space-y-8">
      {/* Styles injectés pour augmenter la taille de police */}
      <style>{customStyles}</style>
      
      {/* Section 1: Résumé */}
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
        <h3 className="text-xl font-medium text-gray-800 mb-4 flex items-center">
          <BookOpen className="h-6 w-6 mr-2 text-blue-600" />
          Résumé
        </h3>
        <div className="prose prose-blue max-w-none markdown-content">
          <ReactMarkdown
            remarkPlugins={[remarkMath]}
            rehypePlugins={[rehypeKatex]}
          >
            {sections.section1}
          </ReactMarkdown>
        </div>
      </div>
      
      {/* Section 2: Démarche proposée */}
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
        <h3 className="text-xl font-medium text-gray-800 mb-4 flex items-center">
          <Target className="h-6 w-6 mr-2 text-indigo-600" />
          Démarche proposée
        </h3>
        <div className="prose prose-indigo max-w-none markdown-content">
          <ReactMarkdown
            remarkPlugins={[remarkMath]}
            rehypePlugins={[rehypeKatex]}
          >
            {sections.section2}
          </ReactMarkdown>
        </div>
      </div>
      
      {/* Section 3: Prochaines étapes */}
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
        <h3 className="text-xl font-medium text-gray-800 mb-4 flex items-center">
          <Clock className="h-6 w-6 mr-2 text-purple-600" />
          Prochaines étapes
        </h3>
        <div className="prose prose-purple max-w-none markdown-content">
          <ReactMarkdown
            remarkPlugins={[remarkMath]}
            rehypePlugins={[rehypeKatex]}
          >
            {sections.section3}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default RecomDisplay;